<div  class="user-notifications" [ngClass]="{'mobile': mobile}">
  <div class="overlay" (click)="closeWidget()" ></div>
  <div class="container-wrap">
    <div class="user-notifications-wrap">
      <div class="user-notifications-header">
        <div class="right">
          <i *ngIf="mobile" class="icon icon-arrow_left cursor-pointer" (click)="closeWidget()"></i>
          {{'user-notification.title' | translate}}
        </div>
        <div class="left">
          <span *ngIf="isShowReadAll" (click)="readAll()" class="cursor-pointer">{{'user-notification.read-all' | translate}}</span>
          <i *ngIf="!mobile" class="icon icon-close cursor-pointer" (click)="closeWidget()"></i>
        </div>
      </div>
      <div class="user-notifications-list" *ngIf="notifications.length; else noData">
        <div *ngFor="let notif of notifications; trackBy: trackById" class="user-notifications-list-item">
          <mat-expansion-panel #refPanel
                               (opened)="openNotification(notif)"
                               class="notification-panel">
            <mat-expansion-panel-header class="notification-panel-header" [ngClass]="{'not-read': !notif?.isRead}">
              <span *ngIf="!notif?.isRead" class="dot"></span>
              <div class="notification-panel-header-data">
                <span class="title">{{notif?.title}}</span>
                <span class="date">{{notif?.createDate | date:'dd.MM.yyyy'}}</span>
              </div>
            </mat-expansion-panel-header>
            <ng-container [ngSwitch]="notif.bodyType">
              <div *ngSwitchCase="NotificationBodyType.Text" class="description">{{notif?.body}}</div>
              <div *ngSwitchCase="NotificationBodyType.Html" class="description" [innerHtml]="notif.safeBody"></div>
            </ng-container>

          </mat-expansion-panel>
        </div>
      </div>
      <ng-template #noData>
        <div class="user-notifications-empty">
          <img src="./assets/img/empty-notifications.svg" alt="">
          <div class="text-1">{{'user-notification.empty-line-1' | translate}}</div>
          <div class="text-2">{{'user-notification.empty-line-2' | translate}}</div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
